export const sharedUrls = {
  apiUrl: 'backend/index.php',
  imagesUrl: 'img/'
}